import { useState } from 'react';
import { useNavigate } from 'react-router';
import Config, { type MultiLang } from '../config';
import Functions from '../functions';
import ItemType from './item-type';
import AdvancedSearchQuery from './lib/AdvancedSearchQuery';
import ItemUtil from './lib/ItemUtil';

interface Props {
    lang: MultiLang;
}

const XoonipsAdvancedSearch = (props: Props) => {
    const { lang } = props;
    const navigate = useNavigate();
    // The child fields mutate this instance directly, so it must survive re-renders.
    const [query] = useState(() => new AdvancedSearchQuery());

    const handleClickSearchButton = () => {
        if (!query.empty()) {
            void navigate(ItemUtil.getSearchByAdvancedKeywordsUrl(query));
        }
    };

    return (
        <div className="advancedSearch">
            <h3>{Functions.mlang('[en]Search Items[/en][ja]アイテム検索[/ja]', lang)}</h3>
            <div className="search">
                <button type="button" className="formButton" onClick={handleClickSearchButton}>
                    Search
                </button>
            </div>
            {Config.XOONIPS_ITEMTYPES.map((type) => {
                return <ItemType.AdvancedSearch key={type} type={type} lang={lang} query={query} />;
            })}
            <div className="search">
                <button type="button" className="formButton" onClick={handleClickSearchButton}>
                    Search
                </button>
            </div>
        </div>
    );
};

export default XoonipsAdvancedSearch;
